import _get from 'lodash/get'
import React, { lazy, Suspense, useEffect, useState } from 'react'
import { HEADER_FOOTER_DATA } from '../../utils/prop-type-shape'
import ShimmerLoader from '../loaders/shimmerLoader'

const mppHeader = () =>
  import('../layout/mpp/mppHeader' /* webpackPrefetch: true */)

const MppHeaderComponent = lazy(mppHeader)

const Header = ({ isLoggedIn, reqContextData, serverData }) => {
  const [isLoaded, setIsLoaded] = useState(false)

  useEffect(() => {
    ;(async () => {
      if (!isLoggedIn) {
        await mppHeader()
        setIsLoaded(true)
      }
    })()
  }, [isLoggedIn, setIsLoaded])

  if (!isLoggedIn) {
    if (isLoaded) {
      // Render Logged Out MPP [Marketing-Components] Header
      const headerData = _get(serverData, 'navigation.mpp.header')
      return (
        <Suspense fallback={<ShimmerLoader />}>
          <MppHeaderComponent
            data={headerData}
            reqContextData={reqContextData}
          />
        </Suspense>
      )
    }
    return <ShimmerLoader />
  }
  return <></>
}

Header.propTypes = HEADER_FOOTER_DATA

export default Header
